var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"","align":"center"}},[_c('h2',{staticClass:"align-self-center mt-5"},[_vm._v(_vm._s(_vm.formData.opportunity_name))]),_c('iframe-integration',{attrs:{"app":_vm.app,"path":_vm.path,"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }